import { createFileRoute } from '@tanstack/react-router';

import {
  OfflineSalesOptimizer,
  OfflineSalesOptimizerSearchParamsSchema,
} from '@/features/offlineSalesOptimizer';

export const Route = createFileRoute(
  '/_app/algorithm-tools/offline-sales-optimizer'
)({
  validateSearch: OfflineSalesOptimizerSearchParamsSchema,
  component: OfflineSalesOptimizer,
});
